const ADMIN_PRINCIPAL_TYPE = "admin";

const isValidAdminSession = (session) =>
  Boolean(
    session &&
      session.principalType === ADMIN_PRINCIPAL_TYPE &&
      typeof session.id === "string" &&
      Array.isArray(session.capabilities)
  );

const hasAdminCapability = (session, capability) =>
  isValidAdminSession(session) && session.capabilities.includes(capability);

export { ADMIN_PRINCIPAL_TYPE, hasAdminCapability, isValidAdminSession };
